import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Service } from './out-of-place-restore.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { DataProtectionVariables } from '../../dataprotection-common/dataprotection-variables';
import { NgForm } from '@angular/forms';
let $ = require('jquery');

@Component({
  selector: 'out-of-place-restore',
  providers: [
    Service, TranslateService
  ],
  styles: [require('./out-of-place-restore.scss')],
  template: require('./out-of-place-restore.html')
})

export class OutOfPlaceRestore {
  @Input('isVisible') isVisible: boolean;
  @Input('mode') mode: string;
  @Input('selectedObject') selectedObject;
  @Input('selectedVDC') selectedVDC;
  @Input('selectedRestore') selectedRestore;
  @Output('onClose') selfClose = new EventEmitter();

  private subscribeHandler;
  private submitted: boolean = false;
  private active: boolean = true;
  private RESTORE_RADIO_OPTIONS = {"ENTIRE_VAPP":"entireVapp", "SPECIFIC_VMS":"specificVms"};
  private restoreRadioSelected = this.RESTORE_RADIO_OPTIONS.ENTIRE_VAPP;
  private isVmListVisible: boolean = false;
  private selectedVMs: Array<Object> = [];
  private isVMsChecked: boolean = true;
  private vAppName = "";
  private vdcName = "";
  private targetVdcResponse = [];
  private targetVdcList = [];
  private storageProfileList = [];
  private selectedTargetVdc;
  private selectedstorageProfile;
  private selectedVappName = "";
  private isRequestPending: boolean = false;

  constructor(public service: Service, private translate: TranslateService) {
    translate.use(GlobalVariables.LOCALE);
  }

  onSubmit(f: NgForm) {
    this.runOutOfPlaceRestore();
  }

  onSubmitButtonClicked(f: NgForm) {
  }

  onCancelButtonClicked() {
    this.closeSelf();
  }

  onRestoreRadiosChanged(value) {
    this.restoreRadioSelected = value;
    switch(value) {
      case this.RESTORE_RADIO_OPTIONS.ENTIRE_VAPP:
        this.isVmListVisible = false;
        this.isVMsChecked = true;
        this.selectedVMs = [];
        break;
      case this.RESTORE_RADIO_OPTIONS.SPECIFIC_VMS:
        this.isVmListVisible = true;
        this.isVMsChecked = false;
        break;
      default :
        this.isVmListVisible = false;
    }
  }

  //Life Cycle Hooks
  ngOnInit() {
  }

  ngOnChanges(changes) {
    if(changes && changes.hasOwnProperty('isVisible') && changes.isVisible && changes.isVisible.hasOwnProperty('currentValue') && changes.isVisible.currentValue
        && this.selectedVDC && this.selectedVDC.id && this.selectedObject && this.selectedObject.name) {
        this.vAppName = this.selectedObject.name;
        this.vdcName = (this.selectedVDC.name)? this.selectedVDC.name : "";

        this.selectedVappName = "";
        this.targetVdcList = this.getDefaultValueForCombos();
        this.storageProfileList = this.getDefaultValueForCombos();
        this.selectedTargetVdc = this.targetVdcList[0].value;
        this.selectedstorageProfile = this.storageProfileList[0].value;

        this.getRestoreTargetVDCs(this.selectedVDC.id);
    }
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
if(this.subscribeHandler) this.subscribeHandler.unsubscribe();
  }

  onVMSelection(vm, event) {
    if(vm && event && event.target) {
      if(event.target.checked && this.selectedVMs.indexOf(vm) === -1) {
        this.selectedVMs.push(vm);
      }
      if(!event.target.checked && this.selectedVMs.indexOf(vm) !== -1) {
        this.selectedVMs.splice(this.selectedVMs.indexOf(vm), 1);
      }
      //To fix bug 1755235
      if(this.selectedVMs.length === 0)
        this.isVMsChecked = false;
      else
        this.isVMsChecked = true;
    }
  }

  getIdArrayFromSelectedVMs() {
    let returnArray = [];
    this.selectedVMs.forEach((vm) => {
      if(vm['id']) returnArray.push(vm['id']);
    });
    return returnArray;
  }

  runOutOfPlaceRestore() {
    if( this.selectedTargetVdc && this.selectedVappName && this.selectedstorageProfile
      && this.selectedRestore && this.selectedRestore.id && this.selectedRestore.id !== '' ) {

      let outOfPlaceRestorePayload = {};
      let vms = this.getIdArrayFromSelectedVMs();
      let spId = this.getStorageProfileId(this.selectedstorageProfile);
      if ( this.restoreRadioSelected === this.RESTORE_RADIO_OPTIONS.SPECIFIC_VMS && vms.length > 0 ) {
          outOfPlaceRestorePayload = {"restorePointId": this.selectedRestore.id,"entityType":"VAPP_RESTORE","vmEntityIds":vms,"restoreAttributes":{"storageProfileId":spId,"vAppName":this.selectedVappName}};
      }else{
          outOfPlaceRestorePayload = {"restorePointId": this.selectedRestore.id,"entityType":"VAPP_RESTORE","restoreAttributes":{"storageProfileId":spId,"vAppName":this.selectedVappName}};
      }

      this.isRequestPending = true;
      this.subscribeHandler = this.service.runOutOfPlaceRestore(this.selectedTargetVdc, outOfPlaceRestorePayload)
        .subscribe(
          res => {
            this.reset();
            this.closeSelf();
          },
          error => this.logError(error, 'out of place restore'),
          () => this.logOperationCompleted('out of place restore')
        );
    }
    else
      this.logError('Incorrect VDC or vApp information');
  }

  getRestoreTargetVDCs(vdcId) {
    this.subscribeHandler = this.service.getRestoreTargetVDCs(vdcId)
      .subscribe(
        vdcList => {
          this.populateTargetVDCs(vdcList, this);
        },
        error => this.logError(error, 'get restore targets'),
        () => this.logOperationCompleted('get restore targets')
      );
  }

  populateTargetVDCs(vdcList, _this) {
    this.targetVdcResponse = vdcList;
    _this.targetVdcList = _this.getDefaultValueForCombos();
    vdcList.map(function(item, index) {
      _this.targetVdcList.push({
          'value': (item.vcd && item.vcd.objectId)? item.vcd.objectId : "",
          'label': (item.vcd && item.vcd.name)? item.vcd.name : ""
      });
    });
  }

  onTargetVdcChange(val) {
    this.selectedTargetVdc = val;
    this.populateStorageProfiles(val, this);
  }

  populateStorageProfiles(targetVdcId, _this) {
    _this.storageProfileList = _this.getDefaultValueForCombos();
    this.targetVdcResponse.map(function(item, index) {
      if(item.vcd && item.vcd.objectId && item.vcd.objectId === targetVdcId && item.vcd.storageProfiles && item.vcd.storageProfiles.vdcStorageProfile) {
        item.vcd.storageProfiles.vdcStorageProfile.map(function(sp, i) {
          _this.storageProfileList.push({
              'value': (sp.href)? sp.href : "",
              'label': (sp.name)? sp.name : ""
          });
        });
      }
    });
  }

  onstorageProfileChange(val) {
    this.selectedstorageProfile = val;
  }

  getStorageProfileId(spHref) {
    let arr = spHref.split("vdcStorageProfile\/");
    return (arr.length > 1)? arr[1] : "";
  }

  getDefaultValueForCombos() {
    return [{'value':'', label: '-Select-'}];
  }

  closeSelf() {
    if (this.selfClose) {
      this.selfClose.emit({
        value: "close"
      });
    }
  }

  reset() {
    this.active = false;
    setTimeout(() => this.active = true, 0);
    this.restoreRadioSelected = this.RESTORE_RADIO_OPTIONS.ENTIRE_VAPP;
    this.isVmListVisible = false;
    this.selectedVMs = [];
    this.selectedVappName = "";
    this.targetVdcList = this.getDefaultValueForCombos();
    this.storageProfileList = this.getDefaultValueForCombos();
    this.selectedTargetVdc = this.targetVdcList[0].value;
    this.selectedstorageProfile = this.storageProfileList[0].value;
  }


  logError(error, origin:String = '') {
    console.error('Error: ', error, (origin !== '')? " Error from " + origin : "");
    this.isRequestPending = false;
  }

  logOperationCompleted(msg: string) {
    console.log('Operation Completed: ', msg)
    this.isRequestPending = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/out-of-place-restore/out-of-place-restore.component.ts